module.exports = __webpack_public_path__ + "HomeBrowser-8nj0URc.svg";